import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withArrow?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withArrow = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black';
  const variants = {
    primary: 'bg-sky-600 hover:bg-sky-500 text-white focus:ring-sky-400 shadow-[0_4px_14px_0_rgba(2,132,199,0.45)] hover:shadow-[0_6px_20px_rgba(2,132,199,0.55)] hover:-translate-y-0.5',
    secondary: 'bg-sky-800 hover:bg-sky-700 text-white focus:ring-sky-500 shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    outline: 'border-2 border-sky-700 hover:border-sky-400 text-sky-100 hover:bg-sky-950/40 focus:ring-sky-400'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-234">
      {children}
      {withArrow && <ArrowRight className="ml-2 w-5 h-5" data-id="element-235" />}
    </motion.button>;
}